import styled from "styled-components";

const AppContent = styled.div`
  height: 100%;
  background: #fff;
`;

export default AppContent;
